import { HTMLAttributes } from 'react'

import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { singleParagraphAnimation } from './animations'
import { cn } from '@/lib/utils'

export type SingleParagraphProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    paragraph: string
    variant: 'large' | 'default'
    align: 'top' | 'center' | 'bottom'
  }>

const SingleParagraph = ({
  paragraph,
  variant,
  align,
  className,
  ...props
}: SingleParagraphProps) => {
  return (
    <Motion animation={singleParagraphAnimation}>
      {(motionRef) => (
        <Section
          ref={motionRef}
          className={cn('px-margin lg:px-0', className)}
          {...props}
        >
          <Grid>
            <div
              className={cn(
                'col-span-2 md:col-span-4 md:col-start-2',
                'lg:col-auto lg:row-span-8 lg:row-start-3 lg:grid lg:max-w-col-span-5',
                {
                  'lg:items-start': align === 'top',
                  'lg:items-center': align === 'center',
                  'lg:items-end': align === 'bottom'
                }
              )}
              data-motion-paragraph-col
            >
              {paragraph ? (
                <Typography
                  paragraph
                  className={cn({
                    'text-[2.88rem] leading-[3.2rem] md:text-[3.6rem] md:leading-[4.2rem]':
                      variant === 'large',
                    'text-[1.6rem] leading-[2.2rem] md:text-[2rem] md:leading-[2.6rem]':
                      variant === 'default'
                  })}
                  data-motion-variant={variant}
                  data-motion-paragraph
                >
                  {paragraph}
                </Typography>
              ) : null}
            </div>
          </Grid>
        </Section>
      )}
    </Motion>
  )
}

export default SingleParagraph
